import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { TranslateLoader } from '@ngx-translate/core'
import { Observable } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class Phrasei18nService implements TranslateLoader {
	constructor(private http: HttpClient) {}

	getTranslation(lang: string): Observable<Record<string, unknown>> {
		const currentLang = lang === 'th' ? 'th-TH' : 'en-GB'

		return new Observable((observer) => {
			// โหลดไฟล์ local JSON
			this.geti18nDefault(currentLang).subscribe({
				next: async (defaultI18n: Record<string, unknown>) => {
					try {
						const url = this.getUrl(currentLang)
						const response = await fetch(url)

						if (!response.ok) {
							console.warn(`❌ Tolgee fetch failed: ${response.status}`)
							observer.next(defaultI18n)
							observer.complete()
							return
						}

						const tolgeeData = await response.json()
						observer.next({ ...defaultI18n, ...tolgeeData })
						observer.complete()
					} catch (error) {
						console.error('❌ Tolgee fetch error', error)
						observer.next(defaultI18n)
						observer.complete()
					}
				},
				error: (err) => {
					console.error('❌ Local JSON error', err)
					observer.next({})
					observer.complete()
				},
			})
		})
	}

	private geti18nDefault(lang: string): Observable<Record<string, unknown>> {
		return this.http.get<Record<string, unknown>>(`${environment.appPath}presentation/assets/i18n/${lang}.json`)
	}

	private getUrl(lang: string): string {
		return `${environment.tolgeeUrl}client-portal/${lang}.json`
	}
}
